module.exports = __webpack_public_path__ + "4e688c19dd2aa20134a83c8dc88464b3.svg";